var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSmileIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Capa_1",
    clipPath: "url(#clip0_16944_17065)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M17.0746 2.92632C13.1734 -0.975283 6.8262 -0.975282 2.92573 2.92538C-0.975495 6.82604 -0.975118 13.1734 2.92611 17.0749C6.8262 20.9753 13.1734 20.9753 17.0743 17.0741C20.9751 13.1734 20.9749 6.82641 17.0746 2.92632ZM15.983 15.9832C12.6841 19.2821 7.31612 19.2825 4.01701 15.9836C0.717337 12.6841 0.717714 7.31557 4.01701 4.01666C7.31593 0.717926 12.6837 0.717549 15.9834 4.01703C19.2823 7.31595 19.2819 12.6845 15.983 15.9832ZM6.26821 7.29238C6.26821 6.6467 6.79188 6.12303 7.43756 6.12303C8.08305 6.12303 8.60672 6.64651 8.60672 7.29238C8.60672 7.93844 8.08305 8.46192 7.43756 8.46192C6.79188 8.46192 6.26821 7.93844 6.26821 7.29238ZM11.5704 7.29238C11.5704 6.6467 12.0944 6.12303 12.7401 6.12303C13.3856 6.12303 13.9092 6.64651 13.9092 7.29238C13.9092 7.93844 13.3858 8.46192 12.7401 8.46192C12.0944 8.46192 11.5704 7.93844 11.5704 7.29238ZM14.3349 12.0816C13.6102 13.7575 11.913 14.8403 10.0114 14.8403C8.0689 14.8403 6.36174 13.752 5.66213 12.0676C5.5422 11.7793 5.67891 11.4482 5.96762 11.3282C6.03853 11.299 6.11207 11.2851 6.18448 11.2851C6.40625 11.2851 6.61669 11.4161 6.70702 11.6339C7.23069 12.8947 8.52771 13.709 10.0114 13.709C11.4615 13.709 12.751 12.8942 13.2964 11.6326C13.4205 11.3458 13.7535 11.2136 14.0401 11.3379C14.3267 11.4621 14.4589 11.795 14.3349 12.0816Z",
    fill: "#666666"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_16944_17065"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmileIcon);
export default __webpack_public_path__ + "static/media/smileIcon.d3f85f8433cf391aba0d585daa393d13.svg";
export { ForwardRef as ReactComponent };